import Vue from 'vue'

import VueI18n from 'vue-i18n'

import enLocale from './en'
import zhCNLocale from './zh-CN'
import zhTWLocale from './zh-TW'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(VueI18n)

const messages = {
    en: {
        ...enLocale,
        ...elementEnLocale
    },
    zhCN: {
        ...zhCNLocale,
        ...elementZhCNLocale
    },
    zhTW: {
        ...zhTWLocale,
        ...elementZhTWLocale
    }
}

const i18n = new VueI18n({
    locale: 'zhCN',
    fallbackLocale: 'zhCN',
    silentFallbackWarn: true, //控制台不打印警告
    silentTranslationWarn: true,
    messages
})

export default i18n